import {
  Component, ChangeDetectionStrategy,
} from '@angular/core'

@Component({
  selector: 'kb-column-list',
  templateUrl: './column-list.component.html',
  styleUrls: ['./column-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ColumnListComponent {

}
